import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
const Index = () => import('views/IndexVue.vue')
const NotFound = () => import('@/views/NotFound.vue')
const Platform = () => import('@/views/platform/PlatformView.vue')
const PlatformHome = () => import('@/views/platform/children/PlatformHome.vue')
const PlatformUpload = () => import('@/views/platform/children/PlatformUpload.vue')
const PlatformManuscript = () => import('@/views/platform/children/PlatformManuscript.vue')
const PlatformAppeal = () => import('@/views/platform/children/PlatformAppeal.vue')
const PlatformData = () => import('@/views/platform/children/PlatformData.vue')
const VideoUpload = () => import('@/views/platform/children/uploadChildren/VideoUpload.vue')
const TextUpload = () => import('@/views/platform/children/uploadChildren/TextUpload.vue')
const VideoDetail = () => import('@/views/detail/VideoDetail.vue')
const Message = () => import('@/views/message/MessageView.vue')
const MessageReply = () => import('@/views/message/children/MessageReply.vue')
const MessageAt = () => import('@/views/message/children/MessageAt.vue')
const MessageLove = () => import('@/views/message/children/MessageLove.vue')
const MessageSystem = () => import('@/views/message/children/MessageSystem.vue')
const MessageConfig = () => import('@/views/message/children/MessageConfig.vue')
const Search = () => import('@/views/search/SearchView.vue')
const SearchVideo = () => import('@/views/search/children/SearchVideo.vue')
const SearchUser = () => import('@/views/search/children/SearchUser.vue')
const Space = () => import('@/views/space/SpaceView.vue')
const SpaceHome = () => import('@/views/space/children/SpaceHome.vue')
const Account = () => import('@/views/account/AccountView.vue')
const AccountHome = () => import('@/views/account/children/AccountHome.vue')
const AccountInfo = () => import('@/views/account/children/AccountInfo.vue')
const AccountAvatar = () => import('@/views/account/children/AccountAvatar.vue')
const AccountSecurity = () => import('@/views/account/children/AccountSecurity.vue')
const AccountWithdraw = () => import('@/views/account/children/AccountWithdraw.vue')
const AccountRecharge = () => import('@/views/account/children/AccountRecharge.vue')
const AccountPurchases = () => import('@/views/account/children/AccountPurchases.vue')
const AccountFavorites = () => import('@/views/account/children/AccountFavorites.vue')
const AccountHistory = () => import('@/views/account/children/AccountHistory.vue')
const PlayHistory = () => import('@/views/history/PlayHistoryView.vue')
const WishPool = () => import('@/views/wish/WishPoolView.vue')
const HotRank = () => import('@/views/hot/HotRankView.vue')
const SingerRank = () => import('@/views/hot/SingerRankView.vue')
const SingerDetail = () => import('@/views/singer/SingerDetailView.vue')
const ProducerList = () => import('@/views/producer/ProducerListView.vue')
const ProducerDetail = () => import('@/views/producer/ProducerDetailView.vue')


const routes = [
    { path: '/', redirect: '' },
    { path: '', name: "index", component: Index, meta: { requestAuth: false } },
    {
        path: '/platform',
        redirect: '/platform/home',
        component: Platform,
        children: [
            { path: '/platform/home', component: PlatformHome, meta: { requestAuth: true } },
            {
                path: '/platform/upload',
                component: PlatformUpload,
                redirect: '/platform/upload/video',
                children: [
                    { path: '/platform/upload/video', component: VideoUpload, meta: { requestAuth: true } },
                    { path: '/platform/upload/text', component: TextUpload, meta: { requestAuth: true } },
                ]
            },
            { path: '/platform/upload-manager', redirect: '/platform/upload-manager/manuscript' },
            { path: '/platform/upload-manager/manuscript', component: PlatformManuscript, meta: { requestAuth: true } },
            { path: '/platform/upload-manager/appeal', component: PlatformAppeal, meta: { requestAuth: true } },
            { path: '/platform/data-up', component: PlatformData, meta: { requestAuth: true } },
        ]
    },
    {
        path: '/message',
        redirect: '/message/reply',
        component: Message,
        children: [
            { path: '/message/reply', component: MessageReply, meta: { requestAuth: true } },
            { path: '/message/at', component: MessageAt, meta: { requestAuth: true } },
            { path: '/message/love', component: MessageLove, meta: { requestAuth: true } },
            { path: '/message/system', component: MessageSystem, meta: { requestAuth: true } },
            { path: '/message/config', component: MessageConfig, meta: { requestAuth: true } },
        ]
    },
    { path: '/video/:vid', component: VideoDetail, meta: { requestAuth: false } },
    { path: '/history', name: 'playHistory', component: PlayHistory, meta: { requestAuth: false } },
    { path: '/wish-pool', name: 'wishPool', component: WishPool, meta: { requestAuth: true } },
    { path: '/hot-rank', name: 'hotRank', component: HotRank, meta: { requestAuth: false } },
    { path: '/singer-rank', name: 'singerRank', component: SingerRank, meta: { requestAuth: false } },
    { path: '/singer/detail', name: 'singerDetail', component: SingerDetail, meta: { requestAuth: false } },
    { path: '/producers', name: 'producerList', component: ProducerList, meta: { requestAuth: false } },
    { path: '/producer/detail', name: 'producerDetail', component: ProducerDetail, meta: { requestAuth: false } },
    {
        path: '/search',
        // 无子路径时（例如空关键词只打开 /search）须进入默认子页，否则父页 router-view 无匹配
        redirect: to => ({
            path: '/search/video',
            query: {
                keyword: to.query.keyword ?? '',
                vType: to.query.vType != null && to.query.vType !== '' ? String(to.query.vType) : '0',
                vStyle: to.query.vStyle != null && to.query.vStyle !== '' ? String(to.query.vStyle) : '0',
                sort: to.query.sort || 'newest',
                isExclusive: to.query.isExclusive != null && to.query.isExclusive !== '' ? String(to.query.isExclusive) : undefined,
                author: to.query.author != null && to.query.author !== '' ? String(to.query.author) : undefined,
            },
        }),
        component: Search,
        meta: { requestAuth: false },
        props: route => ({ keyword: route.query.keyword, vType: route.query.vType, vStyle: route.query.vStyle }),
        children: [
            { path: '/search/video', component: SearchVideo, meta: { requestAuth: false }, props: route => ({ keyword: route.query.keyword, vType: route.query.vType, vStyle: route.query.vStyle, sort: route.query.sort, isExclusive: route.query.isExclusive, author: route.query.author }) },
            { path: '/search/user', component: SearchUser, meta: { requestAuth: false }, props: route => ({ keyword: route.query.keyword }) },
        ]
    },
    {
        path: '/space',
        component: Space,
        meta: { requestAuth: false },
        children: [
            { path: '/space/:uid', component: SpaceHome, meta: { requestAuth: false } },
            // 兼容历史链接，创作者空间统一回到单页作品主页。
            { path: '/space/:uid/video', redirect: to => `/space/${to.params.uid}` },
            { path: '/space/:uid/article', redirect: to => `/space/${to.params.uid}` },
            { path: '/space/:uid/dynamic', redirect: to => `/space/${to.params.uid}` },
            { path: '/space/:uid/favlist', redirect: to => `/space/${to.params.uid}` },
            { path: '/space/:uid/setting', redirect: to => `/space/${to.params.uid}` },
        ]
    },
    {
        path: '/account',
        redirect: '/account/home',
        component: Account,
        meta: { requestAuth: true },
        children: [
            { path: '/account/home', component: AccountHome, meta: { requestAuth: true } },
            { path: '/account/info', component: AccountInfo, meta: { requestAuth: true } },
            { path: '/account/avatar', component: AccountAvatar, meta: { requestAuth: true } },
            { path: '/account/security', component: AccountSecurity, meta: { requestAuth: true } },
            { path: '/account/withdraw', component: AccountWithdraw, meta: { requestAuth: true } },
            { path: '/account/recharge', component: AccountRecharge, meta: { requestAuth: true } },
            { path: '/account/purchases', component: AccountPurchases, meta: { requestAuth: true } },
            { path: '/account/favorites', component: AccountFavorites, meta: { requestAuth: true } },
            { path: '/account/history', component: AccountHistory, meta: { requestAuth: true } },
        ]
    },
    { path: '/:catchAll(.*)', name: "notfound", component: NotFound, meta: { requestAuth: false } },

]

const router = createRouter({
    history: createWebHistory(),
    routes
});

// 本地没有token就跳到登录界面
router.beforeEach((to, from, next) => {
    if (to.path === '/' || to.path === '') {
        if (to.query && to.query.hot === '1') {
            next({ path: '/hot-rank', replace: true });
            return;
        }
    }
    const hasToken = !!localStorage.getItem("teri_token") || !!localStorage.getItem("dj_token");
    if (to.meta.requestAuth && !hasToken) {
        store.state.openLogin = true;
        next({ name: "index", replace: true });
        return;
    }
    next();
});

export default router
